import { render, staticRenderFns } from "./AccostList.vue?vue&type=template&id=28f85474&scoped=true"
import script from "./AccostList.vue?vue&type=script&lang=js"
export * from "./AccostList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f85474",
  null
  
)

export default component.exports